import React, { useEffect, useMemo, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Hero } from './components/Hero';
import { Quiz } from './components/Quiz';
import { Analyzing } from './components/Analyzing';
import { Result } from './components/Result';
import { FinalStep } from './components/FinalStep';
import { Footer } from './components/Footer';
import { questions } from './data/questions';
import { Answers, buildDiagnosis } from './utils/diagnosis';
import { trackEventOnce } from './utils/metaPixel';
type Stage = 'hero' | 'quiz' | 'analyzing' | 'result' | 'final';
export function App() {
  const [stage, setStage] = useState<Stage>('hero');
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState<Answers>({});
  const timeoutRef = useRef<number | undefined>(undefined);
  const diagnosis = useMemo(() => buildDiagnosis(answers), [answers]);
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
  }, [stage]);
  useEffect(() => {
    if (stage !== 'result') return;
    trackEventOnce('Lead', {
      content_name: 'Skin Fresh Index',
      value: diagnosis.score
    });
  }, [stage, diagnosis.score]);
  useEffect(() => () => window.clearTimeout(timeoutRef.current), []);
  const handleAnswer = (value: string) => {
    const question = questions[step];
    setAnswers(prev => ({
      ...prev,
      [question.id]: value
    }));
    timeoutRef.current = window.setTimeout(() => {
      if (step < questions.length - 1) {
        setStep(prev => prev + 1);
      } else {
        setStage('analyzing');
        timeoutRef.current = window.setTimeout(() => setStage('result'), 2200);
      }
    }, 320);
  };
  const handleBack = () => {
    if (step === 0) {
      setStage('hero');
      return;
    }
    setStep(prev => prev - 1);
  };
  const handleRestart = () => {
    setAnswers({});
    setStep(0);
    setStage('hero');
  };
  return <main className="min-h-[100svh] w-full bg-white" data-id="element-0" data-mp="sunbk38ws6eh">
      <AnimatePresence mode="wait" data-id="element-1" data-mp="st2gmciomlg3">
        {stage === 'hero' && <motion.div key="hero" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-2" data-mp="35ozsypftiwt">
            <Hero onStart={() => {
          trackEventOnce('ViewContent', {
            content_name: 'Skin Diagnosis Quiz'
          });
          setStep(0);
          setStage('quiz');
        }} data-id="element-3" data-mp="d45v27vesjoo" />
            <Footer data-id="element-4" data-mp="3bn2ys4st6mvd" />
          </motion.div>}

        {stage === 'quiz' && <motion.div key="quiz" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-5" data-mp="3qbpo8zc5gv0b">
            <Quiz step={step} answers={answers} onAnswer={handleAnswer} onBack={handleBack} data-id="element-6" data-mp="2xtlolam0imi0" />
          </motion.div>}

        {stage === 'analyzing' && <motion.div key="analyzing" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-7" data-mp="18bomcry0clzl">
            <Analyzing data-id="element-8" data-mp="13dws3r9w4ns8" />
          </motion.div>}

        {stage === 'result' && <motion.div key="result" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-9" data-mp="1r3r4y8u7mcch">
            <Result diagnosis={diagnosis} onContinue={() => setStage('final')} onRestart={handleRestart} data-id="element-10" data-mp="1i31bhbsf8y1x" />
          </motion.div>}

        {stage === 'final' && <motion.div key="final" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-11" data-mp="6qiavrwewmt5">
            <FinalStep diagnosis={diagnosis} onBack={() => setStage('result')} data-id="element-12" data-mp="m5x5qz1iswvq" />
          </motion.div>}
      </AnimatePresence>
    </main>;
}